import actions from "actions"

export type ChallengesReducer = {
  ideaFilter: string
  tagFilter: string[]
  ideaIncludes: "submitted" | "draft" | "all"
  groupFilter: string[]
  stampsFilter: string[]
  orgFilter: string[]
  ideaOrder:
    | "createdAt"
    | "default"
    | "positive"
    | "negative"
    | "score"
    | "updatedAt"
    | "voteCount"
    | "completeness"
    | "impact+"
    | "field+"
  ideaOrderDirection: "asc" | "desc"
  ideaPage: number
  ideaLimit: number
  ideaFieldChoices: string[]
  projectBoardFilter: ("assignedToMe" | "unassigned" | "assignedTo+")[]
  projectBoardLanesFilter: string[]
  postFetchPreviewIndex: number | null
  ideaViewType: "card" | "list" | "board"
  filtersVisible: boolean
  adminHasCommented: "commented" | "notCommented" | "all"
  impactFilter: string[]
}

const initialState: ChallengesReducer = {
  ideaFilter: "",
  tagFilter: [],
  ideaIncludes: "all",
  groupFilter: [],
  stampsFilter: [],
  orgFilter: [],
  ideaOrder: "default",
  ideaOrderDirection: "desc",
  ideaPage: 1,
  ideaLimit: 16,
  ideaFieldChoices: [],
  projectBoardLanesFilter: [],
  postFetchPreviewIndex: null,
  ideaViewType: "card",
  filtersVisible: false,
  adminHasCommented: "all",
  projectBoardFilter: [],
  impactFilter: [],
}

export const defaultInitialState: ChallengesReducer = { ...initialState }

function challenges(state = initialState, action) {
  switch (action.type) {
    case actions.challenges.UPDATE_IDEA_FILTERS:
      return { ...state, ...action.data }
    case actions.challenges.SET_IDEA_VIEW_TYPE: {
      return {
        ...state,
        ideaViewType: action.ideaViewType,
        ideaLimit: action.ideaViewType === "card" ? 16 : 30,
      }
    }
    default:
      return state
  }
}

export default challenges
